<template>
    <div id="hello">

    </div>
</template>

<script>
    export default {
        name: 'Default',
        data() {
            return {
                isDay: false,
            }
        },
        props: {
            msg: String
        },
        methods: {
            redirect(route) {
                this.$router.push(route);
            }
        }
    }
</script>

